import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  customRiskPopup: {
    "& .MuiPaper-root": {
      width: 320,
      minHeight: 160
    }
  }
});
